import axios from 'axios'
import { BadRequest } from '../errors/BadRequest'
import { InternalError } from '../errors/InternalError'
import { NotFound } from '../errors/NotFound'

export const request = axios.create({
  baseURL: window.location.origin + '/dashboard/email-editor/api',
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

request.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      if (error.response.status === 400) {
        throw new BadRequest(error.response.data, error.response)
      } else if (error.response.status === 401) {
        const loginWindow = window.open('', 'preview')
        if (loginWindow) {
          loginWindow.location.href = error.response.data.location
        } else {
          window.open(error.response.data.location, '_blank')
        }
      } else if (error.response.status === 404) {
        throw new NotFound()
      } else if (error.response.status === 500) {
        throw new InternalError()
      }
    }
  },
)
